import { Controller } from "@hotwired/stimulus"

// The /network segments sidebar (contacts/_segments). Its links narrow the
// network_list frame, but the sidebar sits outside that frame, so this keeps
// the two in step (People's network_list, Companies' companies_list): a click
// carries the list's current search, sort and view
// across (the links themselves only name the segment), and whenever the list
// frame loads - a sidebar click, a chip, the toolbar pill - the row for the
// filter now showing is the highlighted one.
export default class extends Controller {
    connect() {
        this._sync = this._sync.bind(this)
        document.addEventListener("turbo:frame-load", this._sync)
    }

    disconnect() {
        document.removeEventListener("turbo:frame-load", this._sync)
    }

    choose(event) {
        const link = event.currentTarget
        const url = new URL(link.href, window.location.origin)
        const current = new URLSearchParams(window.location.search)
        ;["q", "sort", "view"].forEach((name) => {
            if (current.get(name)) url.searchParams.set(name, current.get(name))
        })
        link.href = url.pathname + url.search
        this._mark(link.dataset.segmentFilter, link.dataset.segmentGroup)
    }

    _sync(event) {
        const id = event.target.id
        if (!["network_list", "companies_list", "network_segments"].includes(id)) return
        const params = new URLSearchParams(window.location.search)
        this._mark(params.get("filter") || "all", params.get("group") || "")
    }

    _mark(filter, group) {
        this.element.querySelectorAll(".network-segment[data-segment-filter]").forEach((link) => {
            const groupMatches = !link.dataset.segmentGroup || link.dataset.segmentGroup === group
            const active = link.dataset.segmentFilter === filter && groupMatches
            link.classList.toggle("is-active", active)
            if (active) link.setAttribute("aria-current", "page")
            else link.removeAttribute("aria-current")
        })
    }
}
